/* eslint-env es6 */
/* eslint-disable no-restricted-syntax */

/**
 * There are a number of verifications and potential input
 * cleanings that need to be done before this is ready.
 * Currently most of that has not been implemented.
 *
 * - Andrew Yin 06/11/2020
 */

import {v4 as uuidv4} from "uuid";

/**
 * Checks the user's localStorage for cdid (client device id)
 * and gets the value if it exists.
 * Otherwise it generates a uuid and sets it in localStorage for future use.
 *
 * @returns {void}
 */
function checkClientDeviceId() {
	if (window.localStorage) {
		let clientDeviceId = window.localStorage.getItem("cdid") || uuidv4();

		if (!window.localStorage.getItem("cdid")) {
			window.localStorage.setItem("cdid", clientDeviceId);
		}
	}
}

/**
 * gets the first of each specified query param
 * from the current location
 *
 * @returns {object}
 */
function getUTMParams() {
	const params = new URLSearchParams(window.location.search);
	const parsedParams = {
		utm_source: params.get("utm_source"),
		utm_medium: params.get("utm_medium"),
		utm_campaign: params.get("utm_campaign"),
		utm_content: params.get("utm_content"),
		utm_term: params.get("utm_term"),
	};

	return parsedParams;
}

/**
 * Makes ajax call to record new source and client
 *
 * @param {object} params
 */
function recordUTMParams(params) {
	if (window.localStorage) {
		return $.post("/s/sourceRecording/ajax.php", {
			a: "record_source",
			client_device_id: window.localStorage.getItem("cdid"),
			...params,
		});
	}
}

/**
 * Main driver function for search params
 */
function sourceRecordingMain() {
	checkClientDeviceId();
	let params = getUTMParams();
	// only record source if utm_source is found in params
	if (params["utm_source"]) {
		recordUTMParams(params);
	}
}

sourceRecordingMain();
